<template>
  <div class="comment">
    <div class="comment-tile">
      <span>{{ $t('details.catatan') }}</span>
      <span class="count">{{ _value.length }} / {{ MAX_NOTE_LENGTH }}</span>
    </div>
    <div class="comment-input" :class="{ tips: _value.length >= 100 }">
      <MInput
        v-model="_value"
        :max="MAX_NOTE_LENGTH"
        :placeholder="$t('details.commentPlaceholder')"
        :filter="setCommit"
        @focus="onFocus"
      />
    </div>
  </div>
</template>

<script>
import { setCommit } from 'src/utils/common';
import { MAX_NOTE_LENGTH } from 'src/utils/config';
import MInput from '../../../components/MInput';

export default {
  components: { MInput },
  // eslint-disable-next-line vue/require-prop-types
  props: ['value'],
  data() {
    return { MAX_NOTE_LENGTH };
  },
  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
  },
  methods: {
    setCommit,
    onFocus() {
      setTimeout(() => {
        if (document.activeElement?.scrollIntoViewIfNeeded) {
          document.activeElement?.scrollIntoViewIfNeeded();
        } else if (document.activeElement?.scrollIntoView) {
          document.activeElement?.scrollIntoView();
        }
      }, 100);
    },
  },
};
</script>

<style lang="scss" scoped>
.comment {
  background: #fff;
  &-tile {
    padding: 12px 16px;
    background: $grayBg;
    font-size: 12px;
    display: flex;
    .count {
      margin-left: auto;
    }
  }
  &-input {
    background: #fff;
    padding: 15px;
    &.tips {
      :deep(.minput-input) {
        border-color: $negative;
        border-width: 2px;
      }
    }
  }
}
</style>
